import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LeagueContext } from "../contexts/LeagueContext";

const LeagueRequiredRoute = () => {
  const { currentLeague, userLeagues, loading } = useContext(LeagueContext);

  // Don't redirect while loading
  if (loading) {
    return <div>Loading league data...</div>;
  }

  // Redirect to onboarding if user has no leagues
  if (!userLeagues || userLeagues.length === 0) {
    return <Navigate to="/league-onboarding" />;
  }

  // Redirect to onboarding if no current league is set
  if (!currentLeague) {
    return <Navigate to="/league-onboarding" />;
  }

  // Render the component if user has leagues
  return <Outlet />;
};

export default LeagueRequiredRoute;